import * as React from 'react'
import images from '../images'
import { ListItem } from 'material-ui/List'
import Divider from '@material-ui/core/Divider'
import { PublishedJobParams } from '../types'
import * as moment from 'moment'
import { StringResources } from '../localization/StringResources'
import { Strings } from '../localization'
import {Api} from '../services/api/api';
import {PreferenceType} from '../types/enums/PreferenceType';
import dompurify from 'dompurify';

interface TimerProps {
  hours: number
  minutes: number
  seconds: number
  isTimeExpired: boolean
  isErrorDialogOpen: boolean
  jobCategoryName: string
  publishedJobParams: PublishedJobParams
  isThereBid: boolean
  handleErrorDialogClose?: () => void
  handleTimeExpired: () => void
  getTimerValue: (value: string, isBiddingExpiring: boolean) => void
}

interface TimerState {
  hours: number
  minutes: number
  seconds: number
  isTimeExpired: boolean
  isErrorDialogOpen: boolean
  errorTitle?: string
  errorMessage?: string
  interval?: any
  remainingMinutes: number
  remainingSeconds: number
  isThereBid: boolean
  infoText: string
  isBiddingExpiring: boolean
  waitingForBidsText: string
}

export default class Timer extends React.Component<TimerProps, TimerState> {
  constructor(props: any) {
    super(props)
    this.state = {
      hours: this.props.hours,
      minutes: this.props.minutes,
      seconds: this.props.seconds,
      isTimeExpired: this.props.isTimeExpired,
      isErrorDialogOpen: this.props.isErrorDialogOpen,
      isThereBid: this.props.isThereBid,
      infoText: StringResources.getString(Strings.Components.Timer.InfoText.haulerDesc),
      remainingMinutes: 0,
      remainingSeconds: 0,
      isBiddingExpiring: false,
      waitingForBidsText: ''
    }
  }

  async componentWillMount() {
    this.checkTimer()
    this.props.isThereBid && this.sendTimerValue()

    this.setState({
      waitingForBidsText: (await Api.getPreference(PreferenceType.WaitingForBidsMessage)).value
    })
  }

  componentWillReceiveProps(nextProps: TimerProps) {
    if (nextProps.publishedJobParams.secondTimeKeeping && this.props.publishedJobParams.secondTimeKeeping !== nextProps.publishedJobParams.secondTimeKeeping) {

      let timeLeft = nextProps.publishedJobParams.biddingActiveDate + nextProps.publishedJobParams.secondTimeKeeping - moment.utc().valueOf()
      let hours = Math.floor(timeLeft / 3600000)
      let minutes = Math.floor((timeLeft - hours * 3600000) / 60000)
      let seconds = Math.floor((timeLeft - minutes * 60000 - hours * 3600000) / 1000)

      clearInterval(this.state.interval)
      this.setState({
        minutes: minutes,
        seconds: seconds
      })
      this.timer()
    }
    this.setTimeStopBidding()
  }

  checkTimer = () => {
    let timeLeft
    let hours
    let minutes
    let seconds

    if (this.props.publishedJobParams.createDate && this.props.publishedJobParams.createDate !== moment.utc().valueOf()) {
      if (this.props.publishedJobParams.timeKeeping && this.props.publishedJobParams.secondTimeKeeping === 0) {
        timeLeft = this.props.publishedJobParams.createDate + this.props.publishedJobParams.timeKeeping - moment.utc().valueOf()
      } else if (this.props.publishedJobParams.secondTimeKeeping) {
        timeLeft = this.props.publishedJobParams.biddingActiveDate + this.props.publishedJobParams.secondTimeKeeping - moment.utc().valueOf()
      }

      hours = Math.floor(timeLeft / 3600000)
      minutes = Math.floor((timeLeft - hours * 3600000) / 60000)
      seconds = Math.floor((timeLeft - minutes * 60000 - hours * 3600000) / 1000)

      this.setState({
        hours: hours,
        minutes: minutes,
        seconds: seconds
      })
    }
    this.timer()
  }

  componentWillUnmount() {
    clearInterval(this.state.interval)
  }

  timer = () => {
    let interval = setInterval(() => {
      if (this.state.hours <= 0 && this.state.minutes <= 0 && this.state.seconds <= 0) {
        clearInterval(this.state.interval)
        this.setState({ isTimeExpired: true })
        this.props.handleTimeExpired()
      } else if (this.state.seconds === 0) {
        if (this.state.hours !== 0 && this.state.minutes === 0) {
          this.setState(prevState => {
            return { ...prevState, hours: prevState.hours - 1, minutes: 59, seconds: 59 }
          })
        } else if (this.state.minutes !== 0) {
          this.setState(prevState => {
            return { ...prevState, minutes: prevState.minutes - 1, seconds: 59 }
          })
        }
      } else if (this.state.seconds !== 0) {
        this.setState(prevState => {
          return { ...prevState, seconds: prevState.seconds - 1 }
        })
      }
      this.setInfoText()
      this.props.isThereBid && this.sendTimerValue()
    }, 1000)
    this.setState({
      interval: interval
    })
  }

  setTimeStopBidding = () => {
    let timeStopBidding: number = this.props.publishedJobParams.timeStopBidding ? this.props.publishedJobParams.timeStopBidding : 0
    let remainingMinutes: number = Math.floor(timeStopBidding / 60000)
    let remainingSeconds: number = Math.floor((timeStopBidding - remainingMinutes * 60000) / 1000)
    if (this.state.remainingMinutes !== remainingMinutes || this.state.remainingSeconds !== remainingSeconds) {
      this.setState({
        remainingMinutes: remainingMinutes,
        remainingSeconds: remainingSeconds
      })
    }
  }

  setInfoText() {
    if (this.state.hours === 0) {
      if (this.state.remainingMinutes === this.state.minutes) {
        if (this.state.remainingSeconds < this.state.seconds) {
          this.setState({
            infoText: StringResources.getString(Strings.Components.Timer.InfoText.haulerDesc)
          })
        } else {
          this.setState({
            infoText: StringResources.getString(Strings.Components.Timer.InfoText.biddingExpiresSoon),
            isBiddingExpiring: true
          })
        }
      } else if (this.state.remainingMinutes < this.state.minutes) {
        this.setState({
          infoText: StringResources.getString(Strings.Components.Timer.InfoText.haulerDesc)
        })
      } else {
        this.setState({
          infoText: StringResources.getString(Strings.Components.Timer.InfoText.biddingExpiresSoon),
          isBiddingExpiring: true
        })
      }
    } else {
      this.setState({
        infoText: StringResources.getString(Strings.Components.Timer.InfoText.haulerDesc)
      })
    }
  }

  showTime = () => {
    if (this.state.hours !== 0 || this.state.minutes !== 0 || this.state.seconds !== 0) {
      let hoursWithZero = this.state.hours >= 10 ? `${this.state.hours}:` : this.state.hours !== 0 ? `0${this.state.hours}:` : ``
      let minutesWithZero = this.state.minutes >= 10 ? this.state.minutes : `0${this.state.minutes}`
      let secondsWithZero = this.state.seconds >= 10 ? this.state.seconds : `0${this.state.seconds}`
      return `${hoursWithZero}${minutesWithZero}:${secondsWithZero}`
    } else return ``
  }

  sendTimerValue = () => {
    this.props.getTimerValue(this.showTime(), this.state.isBiddingExpiring)
  }

  getWithinTime = () => {
    if (this.state.minutes === 0 && this.state.seconds === 0) {
      return ``
    } else {
      return this.state.minutes + 1
    }
  }

  isOneThirdTimeExpired = () => {
    let jobTimeInSeconds = this.props.publishedJobParams.minutes * 60 + this.props.publishedJobParams.seconds
    let currentTimeLeftInSeconds = this.state.minutes * 60 + this.state.seconds
    if (this.state.hours === 0) {
      if (currentTimeLeftInSeconds < jobTimeInSeconds * 2 / 3) {
        return true
      } else {
        return false
      }
    } else return false
  }

  render() {
      const sanitizer = dompurify.sanitize;
    return (
      <div>
        {
          this.props.jobCategoryName !== '' && !this.state.isTimeExpired ?
            <div className={`Pickup-info ${this.props.isThereBid ? 'waiting-bids' : 'wait-for-accept'}`}>
              {
                this.props.isThereBid ?
                  <Divider style={{ height: 2 }} />
                  :
                  null
              }
              {
                this.props.isThereBid ?
                  <div>
                    <ListItem
                      className={`job-details-list-item magnifying-glass`}
                      disabled={true}
                      leftAvatar={<div className="waiting"><img src={images.magnifyingGlass} /> </div>}
                      secondaryText={
                        <p>
                          <span>{this.state.infoText}</span>
                        </p>
                      }
                      secondaryTextLines={2}
                    />
                  </div>
                  :
                  <div>
                    <ListItem
                      className={`job-details-list-item--waiting timer`}
                      disabled={true}
                      leftAvatar={<div className="waiting"><img src={images.waitingHauler} /></div>}
                    >
                      <div dangerouslySetInnerHTML={{__html: sanitizer(this.state.waitingForBidsText)}} />
                    </ListItem>
                  </div>
              }
            </div> : null
        }
      </div>

    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Timer.tsx